export function assertIsSet<T>(
  obj: T,
  message?: string
): asserts obj is NonNullable<T> {
  if (obj === undefined || obj === null) {
    throw new Error(message ?? `Expected ${obj} to be defined`);
  }
}
